module.exports = __webpack_public_path__ + "static/media/getphy_marker_y.86406d3b.svg";